import React, { useEffect, useState } from 'react';

import { useIntl } from 'react-intl-next';
import { useRouter } from 'react-resource-router';

import DynamicTable from '@atlaskit/dynamic-table';
import { Box, xcss } from '@atlaskit/primitives';

import type { RenderViewProps } from '../../types';
import { ActionsDropdownComponent } from '../thumbnail-actions-dropdown';

import messages from './messages';

type Cell = {
	key: string;
	content: React.ReactElement;
};
type RowItem = {
	key: string;
	cells: Cell[];
	onClick: () => void;
};

export const ListView = ({ reportsConfig }: RenderViewProps) => {
	const { formatMessage } = useIntl();
	const [, { push }] = useRouter();
	const [rows, setRows] = useState<RowItem[]>([]);
	const head = {
		cells: [
			{
				key: 'report',
				content: formatMessage(messages.reportTableHeading),
			},
			reportsConfig.length > 0 &&
			reportsConfig.every((config) => config.id === 'assets-reports-home-page')
				? {
						key: 'actions',
						content: formatMessage(messages.actionsTableHeading),
					}
				: {
						key: 'category',
						content: formatMessage(messages.categoruTableHeading),
					},
		],
	};
	useEffect(() => {
		const tableRow: RowItem[] = [];
		reportsConfig.forEach((config) => {
			config.reports.forEach((report, i) => {
				tableRow.push({
					key: `${config.id}-${i}`,
					cells: [
						{
							key: `report-${config.id}-${i}`,
							content: <Box xcss={cell}>{report.title}</Box>,
						},
						config.sectionName === ''
							? {
									key: `actions-${config.id}-${i}`,
									content: (
										<Box xcss={cell}>
											{report.actions && report.actions?.length > 0 && (
												<ActionsDropdownComponent actions={report?.actions} />
											)}
										</Box>
									),
								}
							: {
									key: `category-${config.id}-${i}`,
									content: <Box xcss={cell}>{config.sectionName}</Box>,
								},
					],
					onClick: () => {
						push(report.link);
					},
				});
			});
		});
		setRows(tableRow);
	}, [push, reportsConfig]);
	return (
		<Box xcss={tableContainer}>
			<DynamicTable head={head} rows={rows} isFixedSize />
		</Box>
	);
};

const tableContainer = xcss({
	marginTop: 'space.200',
});
const cell = xcss({
	paddingTop: 'space.050',
	paddingBottom: 'space.050',
	cursor: 'pointer',
});
